import { render, staticRenderFns } from "./WasteTypeList.vue?vue&type=template&id=3a333e19&scoped=true&"
import script from "./WasteTypeList.vue?vue&type=script&lang=js&"
export * from "./WasteTypeList.vue?vue&type=script&lang=js&"
import style0 from "./WasteTypeList.vue?vue&type=style&index=0&id=3a333e19&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a333e19",
  null
  
)

export default component.exports